import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const MEMBER_OFFERS_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.MEMBER_OFFERS;
/**
 * The member offers box of a book club. Only returned when it has a link, since
 * the box is not shown without one.
 */
export const getBookClubMemberOffers = (subscription) => {
    const chunk = getComponentContentById(subscription.product.components, MEMBER_OFFERS_IDS.ID)?.chunks?.[0];
    if (!chunk)
        return undefined;
    const getText = (componentId) => getComponentContentById(chunk, componentId)?.text?.trim() || undefined;
    const href = getText(MEMBER_OFFERS_IDS.LINK);
    if (!href)
        return undefined;
    return {
        href,
        title: getText(MEMBER_OFFERS_IDS.TITLE),
        text: getText(MEMBER_OFFERS_IDS.TEXT),
        linkText: getText(MEMBER_OFFERS_IDS.LINK_TEXT),
        imageUrl: getComponentContentById(chunk, MEMBER_OFFERS_IDS.IMAGE)
            ?.images?.[0]?.url ?? undefined,
    };
};
